export const ACCOUNT_TYPE = {
    SUPPLIER : "Supplier",
    WAREHOUSE_MANAGER : "Warehouse_Manager",
    YARD_MANAGER:"Yard_managers",
    DRIVER : "Driver",
  }
  